module.exports = __webpack_public_path__ + "static/img/guide.29c4074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/guide.png
// module id = egIW
// module chunks = 0